// import { Injectable } from "@angular/core";
import { get } from "lodash";
import { environment } from "../../environments";
import {
  ApproveParams,
  estimateDefaultFeesWithGasPricesAndLimits,
  ETHAddress,
  getTokenAddress,
  TxOverrides,
} from "@xchainjs/xchain-ethereum/lib";
import { EthUtilsService } from "../KeyStoreSwappingAsset/services/eth-utils.service";
import { User } from "../WalletConnectService/user";
import { BigNumber } from "@ethersproject/bignumber";
import { ethers } from "ethers";
import { erc20ABI } from "../WalletConnectService/erc20.abi";
import {
  AssetETH,
  assetFromString,
  assetToString,
  baseAmount,
} from "@xchainjs/xchain-util";
import { toUtf8Bytes } from "@ethersproject/strings";
import { toast } from "react-toastify";

import { Address } from "@xchainjs/xchain-client";
import { hexlify } from "@ethersproject/bytes";
import { MockClientService } from "../WalletConnectService/mock-client.service";
import { Client as binanceClient } from "@xchainjs/xchain-binance";
import { Client as bitcoinClient } from "@xchainjs/xchain-bitcoin";
import { Client as thorchainClient } from "@xchainjs/xchain-thorchain";
import { Client as litecoinClient } from "@xchainjs/xchain-litecoin";
import { Client as bitcoinCashClient } from "@xchainjs/xchain-bitcoincash";
import { Client as ethereumClient } from "@xchainjs/xchain-ethereum/lib";
import { Chain } from "@xchainjs/xchain-util";
import { Network } from "@xchainjs/xchain-client";
import { Web3 } from "web3";
import { Alert } from "react-bootstrap";

import {
  LOGIN,
  LOGOUT,
  SWAPPING_SUCCESS,
  SWAPPING_REQUEST,
  SWAPPING_FAILED,
  ADDLIQUIDITY_SUCCESS,
  ADDLIQUIDITY_REQUEST,
  GETLIQUIDITY_SUCCESS,
  GETLIQUIDITY_REQUEST,
} from "../../Redux/actions/types";
import axios from "axios";
import { CRYPTOCOMPARE_KEY } from "../environment";
import {
  ETHERSCAN_URL,
  INBOUND_ADDRESSES,
  SERVER_URL_MAIN,
  VIEWBLOCK_URL,
} from "../../Routes/serverRoutes";
import { getPoolShare } from "@thorchain/asgardex-util";
import { add } from "date-fns";
const ethUtilsService = new EthUtilsService();
const alertToast = (error, message) => {
  if (!error) {
    toast.success(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  } else {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
// let web3 = new Web3(window.ethereum);

let binanceAddress;

let bitcoinAddress;

let litecoinAddress;

let etherAddress;

let bitcoinCashAddress;

let thorchainAddress;

let lunaAddress;

//Clients

let userBinanceClient;

let userBtcClient;

let userThorchainClient;

let userEthereumClient;

let userLtcClient;

let userbchClient;

export class XDEFIService {
  MOCK_PHRASE =
    "van caught elder eternal height aisle rule cluster enlist easy twin color";

  mockBinanceClient;
  mockBtcClient;
  mockThorchainClient;
  mockEthereumClient;
  mockLtcClient;
  mockBchClient;

  static listProvider = [
    {
      title: "Ethereum Provider",
      providerPath: "ethereum",
      enabled: true,
      disableNetworkValidation: true,
    },
    {
      title: "Bitcoin Provider",
      providerPath: ["xfi", "bitcoin"],
      enabled: true,
    },
    {
      title: "BinanceDEX Provider",
      providerPath: ["xfi", "binance"],
      enabled: true,
    },
    {
      title: "BitcoinCash Provider",
      providerPath: ["xfi", "bitcoincash"],
      enabled: true,
    },
    {
      title: "LiteCoin Provider",
      providerPath: ["xfi", "litecoin"],
      enabled: true,
    },
    {
      title: "Thorchain Provider",
      providerPath: ["xfi", "thorchain"],
      enabled: true,
    },
  ];
  constructor() {
    // console.log("mockClientService",mockClientService.mockBchClient())
    // console.log("mockClientService",mockClientService)
    // this.mockClientService = mockClientService
    const network =
      environment.network === "testnet" ? Network.Testnet : Network.Mainnet;
    const phrase = this.MOCK_PHRASE;

    this.mockBinanceClient = new binanceClient({ network, phrase });

    this.mockBtcClient = new bitcoinClient({
      network,
      phrase,
      sochainUrl: "https://sochain.com/api/v2",
      blockstreamUrl: "https://blockstream.info",
    });
    this.mockThorchainClient = new thorchainClient({ network, phrase });
    this.mockEthereumClient = new ethereumClient({
      network,
      phrase,
      etherscanApiKey: environment.etherscanKey,
      infuraCreds: { projectId: environment.infuraProjectId },
    });
    this.mockLtcClient = new litecoinClient({ network, phrase });
    this.mockBchClient = new bitcoinCashClient({ network, phrase });
  }

  isValidNetwork() {
    const invalidNetworkProvider = XDEFIService.listProvider.find(
      ({ providerPath, disableNetworkValidation }) => {
        const providerInfo = get(window, providerPath);
        if (disableNetworkValidation || !providerInfo) {
          return false;
        }
        const projectNetwork = environment.network;
        // environment.network === "testnet" ? "testnet" : "mainnet";
        return projectNetwork !== providerInfo.network;
      }
    );
    return !invalidNetworkProvider;
  }

  listEnabledXDFIProviders() {
    return XDEFIService.listProvider.map((provider) => ({
      ...provider,
      // @ts-ignore
      enabled: get(window, provider.providerPath),
    }));
  }

  async initXDEFI() {}

  async getBnbAddress() {
    if (!window.xfi.binance) {
      return;
    }
    return new Promise((resolve, reject) => {
      window.xfi.binance.request(
        {
          method: "request_accounts",
          params: [],
        },
        (err, accounts) => {
          if (err) {
            return reject(err);
          }
          return resolve(accounts[0]);
        }
      );
    });
  }

  async getBtcAddress() {
    if (!window.xfi.bitcoin) {
      return;
    }
    return new Promise((resolve, reject) => {
      window.xfi.bitcoin.request(
        {
          method: "request_accounts",
          params: [],
        },
        (err, accounts) => {
          if (err) {
            return reject(err);
          }
          return resolve(accounts[0]);
        }
      );
    });
  }

  async getBchAddress() {
    if (!window.xfi.bitcoincash) {
      return;
    }
    return new Promise((resolve, reject) => {
      window.xfi.bitcoincash.request(
        {
          method: "request_accounts",
          params: [],
        },
        (err, accounts) => {
          if (err) {
            return reject(err);
          }
          return resolve(accounts[0]);
        }
      );
    });
  }

  async getEthAddress() {
    if (!window.xfi.ethereum) {
      return;
    }

    return window.xfi.ethereum.request({
      method: "eth_requestAccounts",
      params: [],
    });
  }

  async getThorChainAddress() {
    if (!window.xfi.thorchain) {
      return;
    }
    return new Promise((resolve, reject) => {
      window.xfi.thorchain.request(
        {
          method: "request_accounts",
          params: [],
        },
        (err, accounts) => {
          if (err) {
            return reject(err);
          }
          return resolve(accounts[0]);
        }
      );
    });
  }

  async getLtcAddress() {
    if (!window.xfi.litecoin) {
      console.log("xfi not defined");
      return;
    }
    return new Promise((resolve, reject) => {
      window.xfi.litecoin.request(
        {
          method: "request_accounts",
          params: [],
        },
        (err, accounts) => {
          if (err) {
            return reject(err);
          }
          return resolve(accounts[0]);
        }
      );
    });
  }
  async ethereumMemoConversion(data) {
    let arr = [];
    for (let i = 0; i < data.length; i++) {
      arr.push(data.charCodeAt(i).toString(16));
    }
    return "0X" + arr.join("");
  }

  //add Liquidity

  async addLiquidity(
    dispatch,
    fromAsset,
    toAsset,
    amount,
    decimal,
    midgardPool,
    setYayModal,
    setConfirmModal,
    setTransactionHash,
    setStatusLink,
    setLoading,
    fromTicker,
    memoSlip
  ) {
    // let check = await userBinanceClient.getBalance(binanceAddress);
    let charToHex = (data) => {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data.charCodeAt(i).toString(16));
      }
      return "0X" + arr.join("");
    };
    // console.log("heyBalance=======>>", check[0].amount.amount());
    dispatch({ type: ADDLIQUIDITY_REQUEST });
    console.log("from=======>>>", fromAsset.rawData.toString());
    console.log("to=======>>", toAsset, amount, decimal);
    setLoading(true);
    let walletAddressTo;
    let hash;
    let walletAddressFrom;
    console.log("address======", bitcoinAddress);
    switch (fromAsset?.blockchain) {
      case "ETH":
        walletAddressFrom = etherAddress;

        break;
      case "BNB":
        walletAddressFrom = binanceAddress;
        break;

      case "BTC":
        walletAddressFrom = bitcoinAddress;

        break;

      case "LTC":
        walletAddressFrom = litecoinAddress;

        break;

      case "BCH":
        walletAddressFrom = bitcoinCashAddress;

        break;

      case "THOR":
        walletAddressFrom = thorchainAddress;

        break;

      default:
        break;
    }

    switch (toAsset?.blockchain) {
      case "ETH":
        walletAddressTo = etherAddress;

        break;
      case "BNB":
        walletAddressTo = binanceAddress;
        break;

      case "BTC":
        walletAddressTo = bitcoinAddress;

        break;

      case "LTC":
        walletAddressTo = litecoinAddress;

        break;

      case "BCH":
        walletAddressTo = bitcoinCashAddress;

        break;

      case "THOR":
        walletAddressTo = thorchainAddress;

        break;

      default:
        break;
    }

    try {
      let inboundAddress;
      if (fromAsset?.blockchain === "THOR") {
        inboundAddress = "tthor1mrckazz7l67tz435dp9m3qaygzm6xmsqeglrj8";
      } else {
        let inboundApi = await axios.get(`${INBOUND_ADDRESSES}`);
        inboundApi = inboundApi.data;
        inboundAddress = inboundApi.find(
          (data) => data.chain === fromAsset?.blockchain
        );
      }

      console.log("INBOUND CHECKING+++++++++++++", inboundAddress);
      //  const Memo = "=:THOR.RUNE:tthor1fcaf3n4h34ls3cu4euwl6f7kex0kpctkf5p8d7";

      const Memo = `+:${toAsset?.rawData}:${walletAddressTo}:tthor12ctu8edzmpkcww68hu5dh4p8a9gsqc3wmw7ztz:100`;
      console.log("MEMO=========", Memo);
      const send_amount = Number(amount) * Number(Math.pow(10, decimal));
      console.log("send Amount===>>", send_amount);
      let viewblock;
      let data;
      let apiCall;
      let response;
      switch (fromAsset?.blockchain) {
        case "ETH":
          // console.log("checking", web3);
          // let conversion = await this.ethereumMemoConversion(Memo);
          // const accounts = await web3.eth.getAccounts();
          // console.log(accounts);
          response = await userEthereumClient.sendTransaction({
            nonce: "0x00", // ignored by MetaMask

            gasPrice: "0x09184e72a000", // customizable by user during MetaMask confirmation.

            gas: "0x2710", // customizable by user during MetaMask confirmation.

            to: inboundAddress.address, // Required except during contract publications.

            from: etherAddress[0], // must match user's active address.

            value: (amount * 10 ** decimal).toString(), // Only required to send ether to the recipient from the initiating external account.

            data: charToHex(Memo.toString()), // Optional, but used for defining smart contract creation and interaction.

            // chainId: '0x3',
          });
          // response = await ethUtilsService.callDeposit({
          //   inboundAddress: inboundAddress,
          //   asset: assetFromString(fromAsset.rawData),
          //   // amount: amount,
          //   amount: Number(send_amount),
          //   memo: Memo,
          //   ethClient: userEthereumClient,
          // });

          response = response?.hash?.split("x");
          response = response[1];

          const etherScan = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          setStatusLink(etherScan);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);

          break;

        case "BNB":
          console.log("Hey BNB");
          response = await userBinanceClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);
          console.log("response=====>>", viewblock);

          break;

        case "BTC":
          console.log("Hey BTC");

          response = await userBtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),

            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);

          break;

        case "LTC":
          console.log("Hey LTC");
          response = await userLtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);
          console.log("response=====>>", response);

          break;

        case "BCH":
          console.log("Hey BCH==========", userbchClient);

          response = await userbchClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);
          console.log("response=====>>", response);

          break;

        case "THOR":
          console.log("Hey THOR");
          console.log("inound=====>>", inboundAddress);
          response = await userThorchainClient.deposit({
            // recipient: "",
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;
          setStatusLink(viewblock);
          setTransactionHash(response);
          setLoading(false);
          setConfirmModal(false);
          setYayModal(true);
          data = {
            coin: toAsset?.asset,
            amount: amount.toString(),
            address: walletAddressTo.toString(), //to
            transactionId: response.toString(),
            date: new Date().toString(),
            client: walletAddressFrom.toString(), //from,
            network: environment.network.toString(),
          };
          apiCall = await axios.post(
            `${SERVER_URL_MAIN}/add/transaction`,
            data
          );
          console.log("apiCall==============", apiCall);
          console.log("response=====>>", response);

          break;

        default:
          break;
      }
      dispatch({
        type: ADDLIQUIDITY_SUCCESS,
        payload: {
          transactionHash: response,
          transactionHistoryModal: true,
        },
      });
      console.log("response Hey===========", response);
    } catch (error) {
      console.log("error", error);
      // alertToast(true, error?.message || error);
      setLoading(false);
    }
  }

  //Swapping
  async swapping(
    dispatch,
    fromAsset,
    toAsset,
    amount,
    toAmount,
    decimal,
    midgardPool,
    setYayModal,
    setConfirmModal,
    setTransactionHash,
    setStatusLink,
    setLoading,
    fromTicker,
    memoSlip
  ) {
    // let check = await userBinanceClient.getBalance(binanceAddress);
    let charToHex = (data) => {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        arr.push(data.charCodeAt(i).toString(16));
      }
      return "0X" + arr.join("");
    };
    // console.log("heyBalance=======>>", check[0].amount.amount());
    dispatch({ type: SWAPPING_REQUEST });
    console.log("from=======>>>", fromAsset.rawData.toString());
    console.log("to=======>>", toAsset, amount, decimal);
    setLoading(true);
    let walletAddressTo;
    let hash;
    let walletAddressFrom;
    console.log("address======", bitcoinAddress);
    switch (fromAsset?.blockchain) {
      case "ETH":
        walletAddressFrom = etherAddress;

        break;
      case "BNB":
        walletAddressFrom = binanceAddress;
        break;

      case "BTC":
        walletAddressFrom = bitcoinAddress;

        break;

      case "LTC":
        walletAddressFrom = litecoinAddress;

        break;

      case "BCH":
        walletAddressFrom = bitcoinCashAddress;

        break;

      case "THOR":
        walletAddressFrom = thorchainAddress;

        break;

      default:
        break;
    }

    switch (toAsset?.blockchain) {
      case "ETH":
        walletAddressTo = etherAddress;

        break;
      case "BNB":
        walletAddressTo = binanceAddress;
        break;

      case "BTC":
        walletAddressTo = bitcoinAddress;

        break;

      case "LTC":
        walletAddressTo = litecoinAddress;

        break;

      case "BCH":
        walletAddressTo = bitcoinCashAddress;

        break;

      case "THOR":
        walletAddressTo = thorchainAddress;

        break;

      default:
        break;
    }

    try {
      let inboundAddress;
      if (fromAsset?.blockchain === "THOR") {
        inboundAddress = "tthor1mrckazz7l67tz435dp9m3qaygzm6xmsqeglrj8";
      } else {
        let inboundApi = await axios.get(`${INBOUND_ADDRESSES}`);
        inboundApi = inboundApi.data;
        inboundAddress = inboundApi.find(
          (data) => data.chain === fromAsset?.blockchain
        );
      }

      console.log("INBOUND CHECKING+++++++++++++", inboundAddress);
      //  const Memo = "=:THOR.RUNE:tthor1fcaf3n4h34ls3cu4euwl6f7kex0kpctkf5p8d7";

      const Memo = `=:${toAsset?.rawData}:${walletAddressTo}:${memoSlip}:tthor12ctu8edzmpkcww68hu5dh4p8a9gsqc3wmw7ztz:100`;
      console.log("MEMO=========", Memo);
      const send_amount = Number(amount) * Number(Math.pow(10, decimal));
      console.log("send Amount===>>", send_amount);
      let viewblock;
      let data;
      let apiCall;
      let response;
      switch (fromAsset?.blockchain) {
        case "ETH":
          // console.log("checking", web3);
          // let conversion = await this.ethereumMemoConversion(Memo);
          // const accounts = await web3.eth.getAccounts();
          // console.log(accounts);
          response = await userEthereumClient.sendTransaction({
            nonce: "0x00", // ignored by MetaMask

            gasPrice: "0x09184e72a000", // customizable by user during MetaMask confirmation.

            gas: "0x2710", // customizable by user during MetaMask confirmation.

            to: inboundAddress.address, // Required except during contract publications.

            from: etherAddress[0], // must match user's active address.

            value: (amount * 10 ** decimal).toString(), // Only required to send ether to the recipient from the initiating external account.

            data: charToHex(Memo.toString()), // Optional, but used for defining smart contract creation and interaction.

            // chainId: '0x3',
          });
          // response = await ethUtilsService.callDeposit({
          //   inboundAddress: inboundAddress,
          //   asset: assetFromString(fromAsset.rawData),
          //   // amount: amount,
          //   amount: Number(send_amount),
          //   memo: Memo,
          //   ethClient: userEthereumClient,
          // });

          response = response?.hash?.split("x");
          response = response[1];

          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "BNB":
          console.log("Hey BNB");
          response = await userBinanceClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "BTC":
          console.log("Hey BTC");

          response = await userBtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),

            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "LTC":
          console.log("Hey LTC");
          response = await userLtcClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "BCH":
          console.log("Hey BCH==========", userbchClient);

          response = await userbchClient.transfer({
            recipient: inboundAddress.address,
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        case "THOR":
          console.log("Hey THOR");
          console.log("inound=====>>", inboundAddress);
          response = await userThorchainClient.deposit({
            // recipient: "",
            asset: assetFromString(fromAsset.rawData),
            amount: baseAmount(amount * 10 ** decimal),
            memo: Memo,
          });
          viewblock = `https://viewblock.io/thorchain/tx/${response}${VIEWBLOCK_URL}`;

          break;

        default:
          break;
      }
      setStatusLink(viewblock);
      setTransactionHash(response);
      setLoading(false);
      setConfirmModal(false);
      setYayModal(true);
      data = {
        coin: toAsset?.asset,
        amount: toAmount.toString(),
        address: walletAddressTo.toString(), //to
        transactionId: response.toString(),
        date: new Date().toString(),
        client: walletAddressFrom.toString(), //from,
        network: environment.network.toString(),
      };
      let swappingData = {
        type: "Swap",
        fromAmount: amount,
        fromAsset: fromAsset,
        toAmount: toAmount,
        toAsset: toAsset,
        viewblock: viewblock,
      };
      apiCall = await axios.post(`${SERVER_URL_MAIN}/add/transaction`, data);

      dispatch({
        type: SWAPPING_SUCCESS,
        payload: {
          transactionHash: response,
          transactionHistoryModal: true,
          swappingData: swappingData,
        },
      });
      console.log("response Hey===========", response);
    } catch (error) {
      console.log("error", error);
      // alertToast(true, error?.message || error);
      setLoading(false);
    }
  }

  async gettingAssetName(asset) {
    let v = asset.split(".");
    return v[0];
  }
  async connectXDEFI(
    dispatch,
    setMainModel,
    alertToast,
    setLoading,
    midgardPool
  ) {
    function gettingAssetName(asset) {
      let v = asset.split(".");
      return v[0];
    }

    try {
      if (window.xfi) {
        dispatch({ type: LOGOUT });
        let clients = {};
        let mainClients = [];
        let addresses = [];
        userBinanceClient = this.mockBinanceClient;

        userBtcClient = this.mockBtcClient;
        userThorchainClient = this.mockThorchainClient;
        userEthereumClient = this.mockEthereumClient;
        userLtcClient = this.mockLtcClient;
        userbchClient = this.mockBchClient;
        const [thorAddress] = await Promise.all([
          this.getThorChainAddress(),
          new Promise((resolve) => setTimeout(resolve, 100)),
        ]);

        const [
          bnbAddress,
          btcAddress,
          bchAddress,
          ethAddresses,
          ltcAddress,
          thorAddresses,
        ] = await Promise.all([
          this.getBnbAddress(),
          this.getBtcAddress(),
          this.getBchAddress(),
          this.getEthAddress(),
          this.getLtcAddress(),
          this.getThorChainAddress(),
        ]);
        binanceAddress = bnbAddress;
        bitcoinAddress = btcAddress;
        litecoinAddress = ltcAddress;
        etherAddress = ethAddresses;
        bitcoinCashAddress = bchAddress;
        thorchainAddress = thorAddresses;

        //Bitcoin
        try {
          let BtcBalance = await userBtcClient.getBalance(btcAddress);
          let btcTransaction = await userBtcClient.getTransactions({
            address: btcAddress,
          });
          clients.Transactions = btcTransaction;
          clients.Balance = BtcBalance;
          clients.Address = btcAddress;
          addresses.push(btcAddress);
          mainClients.push({ ...clients });
        } catch (error) {
          console.log("error======", error);
        }
        //BCH

        try {
          let BchBalance = await userbchClient.getBalance(bchAddress);
          let bchTransaction = await userbchClient.getTransactions({
            address: bchAddress,
          });
          clients.Transactions = bchTransaction;
          clients.Balance = BchBalance;
          clients.Address = bchAddress;
          addresses.push(bchAddress);
          mainClients.push({ ...clients });
        } catch (error) {
          console.log(error);
        }
        //BNB
        try {
          console.log("BINANCE ADDRESS ==========", bnbAddress);
          let BnbBalance = await userBinanceClient.getBalance(bnbAddress);
          console.log("BNB balance========", BnbBalance);
          if (BnbBalance?.length > 0) {
            let bnbTransaction = await userBinanceClient.getTransactions({
              address: bnbAddress,
            });
            addresses.push(bnbAddress);

            clients.Transactions = bnbTransaction;

            clients.Balance = BnbBalance;
            clients.Address = bnbAddress;

            mainClients.push({ ...clients });
          }
        } catch (error) {
          console.log(error);
        }
        //LTC
        try {
          let LtcBalance = await userLtcClient.getBalance(ltcAddress);
          let ltcTransaction = await userLtcClient.getTransactions({
            address: ltcAddress,
          });
          clients.Transactions = ltcTransaction;
          clients.Balance = LtcBalance;
          clients.Address = ltcAddress;
          addresses.push(ltcAddress);

          mainClients.push({ ...clients });
        } catch (error) {
          console.log(error);
        }
        //ETH

        try {
          let EthBalance = await userEthereumClient.getBalance(ethAddresses[0]);
          console.log("ETH BALANACE===========", EthBalance);
          let ethTransaction = await userEthereumClient.getTransactions({
            address: ethAddresses[0],
          });
          clients.Transactions = ethTransaction;
          let balance = "";

          let b1 = EthBalance[0]?.amount.amount();
          for (let i = 0; i < b1.c.length; i++) {
            balance = balance.toString() + b1.c[i].toString();
          }
          console.log("balance ==========", balance);
          //Start Tokens Implementation

          let check = await axios.get(
            `https://api.ethplorer.io/getAddressInfo/${ethAddresses[0]}?apiKey=freekey`
          );

          if (check && check.data && check.data.tokens) {
            let ethTokens = check.data.tokens;
            let ethClient = {};
            ethTokens.map((d) => {
              let amountCheck = {
                type: "BASE",
                decimal: Number(d?.tokenInfo?.decimals),
                amount: () => {
                  return {
                    c: [Number(d?.rawBalance), 1],
                  };
                },
              };
              let asset = {
                chain: "ETH",
                symbol: d?.tokenInfo?.symbol,
                ticker: d?.tokenInfo?.symbol,
              };
              ethClient.asset = asset;
              ethClient.amount = amountCheck;

              let newClient = { ...ethClient };
              EthBalance.push({ ...newClient });

              console.log("Getting Tokens=============>>>>", newClient);
            });
          }
          //END Tokens Implementation
          let amount = {
            type: "BASE",
            decimal: 18,
            amount: () => {
              return {
                c: [Number(balance), 1],
              };
            },
          };
          EthBalance[0].amount = amount;

          clients.Balance = EthBalance;

          clients.Address = ethAddresses[0];
          addresses.push(ethAddresses[0]);

          mainClients.push({ ...clients });
        } catch (error) {
          console.log(error);
        }
        //THOR

        try {
          let ThorBalance = await userThorchainClient.getBalance(thorAddresses);
          let thorTransaction = await userThorchainClient.getTransactions({
            address: thorAddresses,
          });
          clients.Transactions = thorTransaction;
          clients.Balance = ThorBalance;
          clients.Address = thorAddresses;
          addresses.push(thorAddresses);

          mainClients.push({ ...clients });
          console.log("mainClients======>>", addresses);
        } catch (error) {
          console.log(error);
        }

        // other work
        let concatAssetName = "";
        let totalAmountInBTC = 0;
        let totalAmountInUSD = 0;
        let transactionHistory = [];
        let assetBalance = [];
        console.log("MainClients=====>>", mainClients);
        mainClients.map((d, mainKey) => {
          d.Balance.map((t, key) => {
            let asset = t?.asset?.ticker?.split("/");
            if (asset[1]) {
              asset = asset[1];
            } else {
              asset = asset[0];
            }
            concatAssetName = concatAssetName + asset + ",";
            // console.log("TICKER", asset, t.amount.amount());
          });
          d.Transactions.txs.map(async (t, key) => {
            let apiRes = await axios.get(
              `${SERVER_URL_MAIN}/get/transaction/status/${t?.hash}`
            );
            let apiData = apiRes?.data;
            if (Number(apiData.count) > 0) {
              t.status = apiData?.actions[0]?.type;
            } else {
              t.status = "Deposit";
            }
            console.log("HEY CHECK HERE======", apiData);

            if (t.asset.chain.toLowerCase() === "btc") {
              let res;
              if (Number(apiData.count) > 0) {
                if (
                  (await gettingAssetName(
                    apiData?.actions[0]?.out[0]?.coins[0]?.asset.toLowerCase()
                  )) === "btc"
                ) {
                  res =
                    Number(apiData?.actions[0]?.out[0]?.coins[0]?.amount) /
                    Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                } else {
                  res =
                    Number(apiData?.actions[0]?.in[0]?.coins[0]?.amount) /
                    Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                }
                // res =
                //   Number(apiData?.actions[0]?.out[0]?.coins[0]?.amount) /
                //   Math.pow(10, Number(t?.to[0]?.amount?.decimal));
                t.transferAmount = res;
                transactionHistory.push(t);
              }
            } else {
              let res;
              if (t?.to?.length > 1) {
                res =
                  Number(t?.to[1]?.amount?.amount()?.c[0]) /
                  Math.pow(10, Number(t?.to[1]?.amount?.decimal));
              } else {
                res =
                  Number(t?.to[0]?.amount?.amount()?.c[0]) /
                  Math.pow(10, Number(t?.to[0]?.amount?.decimal));
              }

              t.transferAmount = res;
              transactionHistory.push(t);
            }
          });
        });
        let apiDataBTC = await axios.get(
          `https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=${concatAssetName}&api_key=${CRYPTOCOMPARE_KEY}`
        );
        let apiDataUSD = await axios.get(
          `https://min-api.cryptocompare.com/data/price?fsym=USD&tsyms=${concatAssetName}&api_key=${CRYPTOCOMPARE_KEY}`
        );
        let dataBTC = apiDataBTC.data;
        let dataUSD = apiDataUSD.data;

        console.log("DATA IN USD==========>>", dataUSD);
        mainClients.map((d, mainKey) => {
          d.Balance.map((t, key) => {
            console.log(t?.asset?.ticker + "======>", t?.amount?.amount());
            let asset = t?.asset?.ticker?.split("/");
            if (asset[1]) {
              asset = asset[1];
            } else {
              asset = asset[0];
            }
            // console.log("heyData=====>>",asset, data[asset]);

            let existOrNot = midgardPool.find((d) => d.asset === asset);
            if (existOrNot || asset === "RUNE") {
              console.log(
                "CHECKING BALANCE================",
                t?.asset?.ticker,
                t?.amount?.amount()
              );
              let value =
                Number(t.amount.amount().c[0]) /
                Math.pow(10, Number(t.amount.decimal));
              if (isNaN(value)) {
                value = 0;
              }
              // totalAmountInBTC = totalAmountInBTC + value;
              // console.log("Value Before", asset, value);
              console.log("dataUSD=====>>", dataUSD);
              let valueBTC = value / dataBTC[asset];
              let valueUSD = value / dataUSD[asset];
              t.balanceUSD = valueUSD;
              t.marketPriceUSD = 1 / dataUSD[asset];
              totalAmountInUSD = totalAmountInUSD + valueUSD;
              totalAmountInBTC = totalAmountInBTC + valueBTC;
              assetBalance.push(t);
            }
          });
        });
        // .then((res) => {
        // })
        // .catch((err) => {
        //   alertToast(true, "CryptoCompare: Failed");
        // });

        setLoading(false);
        setMainModel(false);
        dispatch({
          type: LOGIN,
          payload: {
            KeyStoreClient: mainClients,
            overallBalance_USD: totalAmountInUSD,
            overallBalance_BTC: totalAmountInBTC,
            transactionHistory: transactionHistory,
            assetBalance: assetBalance,
            isLoggedin: true,
            walletType: "XDEFI",
            walletAddress: ethAddresses[0],
          },
        });

        alertToast(false, "Wallet connected!");

        // Start getLiquidityAdditionPools

        const gettingAssetNameLiquidity = (data) => {
          let v = data?.split("-");
          let c = v[0]?.split(".");
          return c[1];
        };
        const gettingChainNameLiquidity = (data) => {
          let v = data?.split("-");
          let c = v[0]?.split(".");
          return c[0];
        };

        const decimalValue = {
          BTC: 8,
          ETH: 18,
          BCH: 8,
          LTC: 8,
          THOR: 8,
          BNB: 8,
        };

        dispatch({
          type: GETLIQUIDITY_REQUEST,
        });
        const runeData = await axios.get(`${SERVER_URL_MAIN}/get/rune/data`);

        let liquidityAdded = [];
        try {
          let totalPoolBalance = 0;

          let apiRes = await axios.get(
            // `${SERVER_URL_MAIN}/get/pools/against/client/${thorchainAddress}`
            `${SERVER_URL_MAIN}/get/pools/against/client/thor14wtqzhe9cj7jjtwkv4436jz00xphwr6m3zq9z8`
            // `${SERVER_URL_MAIN}/get/pools/against/client/thor16a3qmun949ptwtclrgxjurcnr7nt9h49gsa5w3`
          );
          liquidityAdded = apiRes?.data?.pools;

          liquidityAdded.map(async (data) => {
            let chain = gettingChainNameLiquidity(data?.pool);
            let asset = gettingAssetNameLiquidity(data?.pool);

            let decimal;
            switch (chain.toLowerCase()) {
              case "eth":
                decimal = decimalValue.ETH;
                break;
              case "bnb":
                decimal = decimalValue.BNB;
                break;
              case "bch":
                decimal = decimalValue.BCH;
                break;
              case "btc":
                decimal = decimalValue.BTC;
                break;
              case "rune":
                decimal = decimalValue.THOR;
                break;
              case "ltc":
                decimal = decimalValue.LTC;
                break;
              default:
                break;
            }
            let priceInUSD = await axios.get(
              `https://min-api.cryptocompare.com/data/price?fsym=${asset}&tsyms=USD&api_key=${CRYPTOCOMPARE_KEY}`
            );
            let runeAdded = Number(data?.runeAdded / Math.pow(10, decimal));
            let runeAddedUSD =
              runeAdded * Number(runeData?.data?.assetPriceUSD);
            let res = midgardPool?.find(
              (t) =>
                t?.rawData.toLowerCase() === data?.pool.toString().toLowerCase()
            );
            res.assetDepthUSD = res?.assetDepth * priceInUSD?.data?.USD;
            const addedUSD =
              (data?.assetAdded / Math.pow(10, decimal)) *
                priceInUSD?.data?.USD +
              runeAddedUSD;
            data.assetAddedUSD = addedUSD;

            totalPoolBalance = Number(totalPoolBalance) + Number(addedUSD);
          });
          console.log("hey khizer==========", totalPoolBalance);

          dispatch({
            type: GETLIQUIDITY_SUCCESS,
            payload: {
              liquidityAdded: liquidityAdded,
              totalPoolBalance: totalPoolBalance,
            },
          });
        } catch (error) {
          console.log("error============", error);
        }

        // END getLiquidityAdditionPools
        // Binance
        userBinanceClient.transfer = async (transferParams) => {
          return new Promise((resolve, reject) => {
            window.xfi.binance.request(
              {
                method: "transfer",
                params: [
                  {
                    ...transferParams,
                    from: bnbAddress,
                    amount: {
                      amount: transferParams.amount.amount().toString(),

                      decimals: transferParams.amount.decimal,
                    },
                  },
                ],
              },
              (err, result) => {
                if (err) {
                  return reject(err);
                }
                return resolve(result);
              }
            );
          });
        };

        // Bitcoin
        userBtcClient.transfer = async (transferParams) => {
          console.log("userBtcClient.transfer", transferParams);
          return new Promise((resolve, reject) => {
            window.xfi.bitcoin.request(
              {
                method: "transfer",
                params: [
                  {
                    ...transferParams,
                    from: btcAddress,
                    amount: {
                      amount: transferParams.amount.amount().toString(),

                      decimals: transferParams.amount.decimal,
                    },
                  },
                ],
              },
              (err, result) => {
                if (err) {
                  return reject(err);
                }
                return resolve(result);
              }
            );
          });
        };

        // BCH
        userbchClient.transfer = async (transferParams) => {
          console.log("HEY BOI++++++++++", transferParams);
          return new Promise((resolve, reject) => {
            window.xfi.bitcoincash.request(
              {
                method: "transfer",
                params: [
                  {
                    ...transferParams,
                    from: bchAddress,
                    amount: {
                      amount: transferParams.amount.amount().toString(),
                      decimals: transferParams.amount.decimal,
                    },
                  },
                ],
              },
              (err, result) => {
                if (err) {
                  return reject(err);
                }
                return resolve(result);
              }
            );
          });
        };

        // Eth
        userEthereumClient.approve = async ({
          // spender,
          // sender,
          spenderAddress,
          contractAddress,
          amount,
          feeOptionKey,
        }) => {
          const gasPrice =
            feeOptionKey &&
            BigNumber.from(
              (
                await userEthereumClient
                  .estimateGasPrices()
                  .then((prices) => prices[feeOptionKey])
                  .catch(() => {
                    const { gasPrices } =
                      estimateDefaultFeesWithGasPricesAndLimits();
                    return gasPrices[feeOptionKey];
                  })
              )
                .amount()
                .toFixed()
            );
          const gasLimit = await userEthereumClient
            .estimateApprove({ spenderAddress, contractAddress, amount })
            .catch(() => undefined);

          const txAmount = amount
            ? BigNumber.from(amount.amount().toFixed())
            : BigNumber.from(2).pow(256).sub(1);
          const contract = new ethers.Contract(contractAddress, erc20ABI);
          const unsignedTx = await contract.populateTransaction.approve(
            spenderAddress,
            txAmount,
            {
              from: userEthereumClient.getAddress(),
              gasPrice,
              gasLimit,
            }
          );
          unsignedTx.from = ethAddresses[0];
          return window.ethereum
            .request({
              method: "eth_sendTransaction",
              params: [unsignedTx],
            })
            .then((hash) => {
              return {
                hash,
              };
            });
        };
        const oldWallet = userEthereumClient.getWallet();
        oldWallet.getAddress = async () => ethAddresses[0];
        userEthereumClient.sendTransaction = (unsignedTx) => {
          unsignedTx.value = hexlify(BigNumber.from(unsignedTx.value || 0));
          return window.ethereum
            .request({
              method: "eth_sendTransaction",
              params: [unsignedTx],
            })
            .then((hash) => {
              return {
                hash,
              };
            });
        };
        oldWallet.signTransaction = (unsignedTx) => {
          unsignedTx.value = hexlify(BigNumber.from(unsignedTx.value || 0));

          return window.ethereum.request({
            method: "eth_signTransaction",
            params: [unsignedTx],
          });
        };
        const newGetWallet = () => {
          return oldWallet;
        };
        userEthereumClient.getWallet = newGetWallet;
        userEthereumClient.transfer = async ({
          asset,
          memo,
          amount,
          recipient,
          feeOptionKey,
          gasPrice,
          gasLimit,
        }) => {
          console.log({
            method: "ethCLient.transfer",
            asset,
            memo,
            amount,
            recipient,
            feeOptionKey,
            gasPrice,
            gasLimit,
          });
          try {
            const txAmount = BigNumber.from(amount.amount().toFixed());

            let assetAddress;
            if (asset && assetToString(asset) !== assetToString(AssetETH)) {
              assetAddress = getTokenAddress(asset);
            }

            const isETHAddress = assetAddress === ETHAddress;

            // feeOptionKey

            const defaultGasLimit = isETHAddress
              ? BigNumber.from(21000)
              : BigNumber.from(100000);

            let overrides = {
              gasLimit: gasLimit || defaultGasLimit,
              gasPrice: gasPrice && BigNumber.from(gasPrice.amount().toFixed()),
            };

            // override `overrides` if `feeOptionKey` is provided
            if (feeOptionKey) {
              const _gasPrice = await userEthereumClient
                .estimateGasPrices()
                .then((prices) => prices[feeOptionKey])
                .catch(
                  () =>
                    estimateDefaultFeesWithGasPricesAndLimits().gasPrices[
                      feeOptionKey
                    ]
                );
              const _gasLimit = await userEthereumClient
                .estimateGasLimit({ asset, recipient, amount, memo })
                .catch(() => defaultGasLimit);

              overrides = {
                gasLimit: _gasLimit,
                gasPrice: BigNumber.from(_gasPrice.amount().toFixed()),
              };
            }

            let txResult;
            if (assetAddress && !isETHAddress) {
              // Transfer ERC20
              const contract = new ethers.Contract(assetAddress, erc20ABI);
              const unsignedTx = await contract.populateTransaction.transfer(
                recipient,
                txAmount,
                Object.assign({}, overrides)
              );
              unsignedTx.from = ethAddresses[0];
              txResult = await window.ethereum.request({
                method: "eth_sendTransaction",
                params: [unsignedTx],
              });
            } else {
              // Transfer ETH
              const transactionRequest = Object.assign(
                { to: recipient, value: txAmount },
                {
                  ...overrides,
                  data: memo ? toUtf8Bytes(memo) : undefined,
                }
              );
              txResult = await window.ethereum.request({
                method: "eth_sendTransaction",
                params: [transactionRequest],
              });
            }

            return txResult.hash || txResult;
          } catch (error) {
            console.error(error);
            return Promise.reject(error);
          }
        };

        userEthereumClient.call = async ({
          walletIndex,
          contractAddress,
          abi,
          funcName,
          funcParams,
        }) => {
          try {
            let params = funcParams ?? [];
            if (!contractAddress) {
              return Promise.reject(new Error("address must be provided"));
            }
            const contract = new ethers.Contract(
              contractAddress,
              abi,
              userEthereumClient.getProvider()
            );
            const txResult = await contract[funcName](...params, {
              from: ethAddresses[0],
            });
            console.log({ txResult });
            return txResult;
          } catch (error) {
            console.error(error);
            console.error("stack");
            return Promise.reject(error);
          }
        };
        // Thor
        userThorchainClient.deposit = async (depositParams) => {
          console.log("userThorchainClient.deposit", depositParams);
          return new Promise((resolve, reject) => {
            window.xfi.thorchain.request(
              {
                method: "deposit",
                params: [
                  {
                    ...depositParams,
                    from: thorAddress,
                    amount: {
                      amount: depositParams.amount.amount().toString(),
                      decimals: depositParams.amount.decimal,
                    },
                  },
                ],
              },
              (err, result) => {
                if (err) {
                  return reject(err);
                }
                return resolve(result);
              }
            );
          });
        };
        userThorchainClient.transfer = async (transferParams) => {
          console.log("userThorchainClient.transfer", transferParams);
          return new Promise((resolve, reject) => {
            window.xfi.thorchain.request(
              {
                method: "transfer",
                params: [
                  {
                    ...transferParams,
                    from: thorAddress,
                    amount: {
                      amount: transferParams.amount.amount().toString(),
                      decimals: transferParams.amount.decimal,
                    },
                  },
                ],
              },
              (err, result) => {
                if (err) {
                  return reject(err);
                }
                return resolve(result);
              }
            );
          });
        };
        // Ltc
        userLtcClient.transfer = async (transferParams) => {
          console.log("userLtcClient.transfer", transferParams);
          return new Promise((resolve, reject) => {
            window.xfi.litecoin.request(
              {
                method: "transfer",
                params: [
                  {
                    ...transferParams,
                    from: ltcAddress,
                    amount: {
                      amount: transferParams.amount.amount().toString(),
                      decimals: transferParams.amount.decimal,
                    },
                  },
                ],
              },
              (err, result) => {
                if (err) {
                  return reject(err);
                }
                return resolve(result);
              }
            );
          });
        };

        console.log({
          thorAddress,
          bnbAddress,
          btcAddress,
          bchAddress,
          ethAddresses,
          ltcAddress,
        });
        const newUser = new User({
          type: "XDEFI",
          wallet: thorAddress,
          clients: {
            binance: userBinanceClient,
            bitcoin: userBtcClient,
            bitcoinCash: userbchClient,
            thorchain: userThorchainClient,
            ethereum: userEthereumClient,
            litecoin: userLtcClient,
          },
        });

        window.xfi.thorchain.on("chainChanged", (obj) => {
          // console.log('changed', obj);
          // const envNetwork =
          //   environment.network === 'testnet' ? 'testnet' : 'mainnet';
          // if (obj.network !== envNetwork) {
          //   // alert("XDEFI: Incorrect network, Reloading");
          //   window.location.reload();
          // }
          window.location.reload();
        });

        return newUser;
      } else {
        alert("Please install XDEFI extension");
      }
    } catch (error) {
      console.log(error);
      // alertToast(true, error.message || error);
    }
  }
  getMockClientByChain(chain) {
    switch (chain) {
      case "BTC":
        return this.mockBtcClient;

      case "ETH":
        return this.mockEthereumClient;

      case "BNB":
        return this.mockBinanceClient;

      case "BCH":
        return this.mockBchClient;

      case "LTC":
        return this.mockLtcClient;

      case "THOR":
        return this.mockThorchainClient;
    }

    throw new Error(`mock client no matching client for chain: ${chain}`);
  }
}
